export default __webpack_public_path__ + "baee095fd33bdb934b696b364506cb25.png";